import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const AddProjectPlan = Loadable(lazy(() => import('./AddProjectPlan')));
const ProjectPlanCalendar = Loadable(lazy(() => import('./ProjectPlanCalendar')));

const ProjectPlanDayRoutes = [
  {
    path: '/projectplanday/manage',
    element: <AddProjectPlan />,
    auth: authRoles.admin,
  },
  {
    path: '/projectplanday/calendar',
    element: <ProjectPlanCalendar />,
    auth: authRoles.admin,
  },
];

export default ProjectPlanDayRoutes;
